export default __webpack_public_path__ + "static/media/battery-box.b436517c.svg";